/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */

const initialState = () => ({
  __activityLogs: [],
  __activityLogInterval: null,
});

export { initialState as state };

export const mutations = {
  add(state, data) {
    let { __activityLogs } = state;

    // Just in case not an array
    if (!Array.isArray(__activityLogs)) {
      __activityLogs = [];
    }
    __activityLogs.push(data);

    state.__activityLogs = __activityLogs;
  },
  interval(state, data) {
    state.__activityLogInterval = data + 0; // cooerce to primitive to avoid circular reference
  },
  reset(state) {
    clearInterval(state.__activityLogInterval);
    state.__activityLogs = [];
    state.__activityLogInterval = null;
  },
};

export const actions = {};
